export default class Logger {
  static debug() {
    return process.env.APP_ENV === 'development';
  }

  static message(...args: any[]) {
    if (Logger.debug()) {
      const debug = document.querySelector('.debug');
      if (debug) {
        debug.innerHTML += '<br />';
        args.map((a) => {
          debug.innerHTML += `${a.toString()} `;
        });
      }
    }
  }

  static log(...args: any[]) {
    if (Logger.debug()) {
      args.unshift('%c[DEBUG]', 'font-weight: bold; color:#999;');
      console.info.apply(console, args);
    }
  }

  static info(...args: any[]) {
    if (Logger.debug()) {
      args.unshift('%c[INFO]', 'font-weight: bold; color:#0D47A1;');
      console.info.apply(console, args);
    }
  }

  static trace(...args: any[]) {
    if (Logger.debug()) {
      console.info.apply(console, args);
    }
  }

  static error(...args: any[]) {
    if (Logger.debug()) {
      args.unshift('%c[ERROR]', 'font-weight: bold; color:#ff1744;');
      console.info.apply(console, args);
    }
  }

  static assert(...args: any[]) {
    if (Logger.debug()) {
      args.unshift('%c[ASSERT]', 'font-weight: bold; color:#f44336;');
      console.info.apply(console, args);
    }
  }
}
